module.exports = {
      id: "comments-outline-usage",
      viewBox: "0 0 32 36",
      url: "/" + "sprite-f96a299a5e63739e5b36582e48c149a3.svg#comments-outline",
      toString: function () {
        return this.url;
      }
    }